// extracted by mini-css-extract-plugin
export default {"menu":"Nav_menu__kMryx","item":"Nav_item__Qmtdm","link":"Nav_link__GqrGx"};